module.exports = __webpack_public_path__ + "img/draw-boxmoney.235e57f7.png";